import { Pill, type PillSize, type PillVariant } from "@clipboard-health/ui-components";

interface OrientationRequiredPillProps {
  size?: PillSize;
  variant?: PillVariant;
  compact?: boolean;
}

export function OrientationRequiredPill(props: OrientationRequiredPillProps) {
  const { size = "small", variant = "filled", compact = false } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label={compact ? undefined : "Orientation required"}
      iconType="document"
      backgroundColor={(theme) => theme.palette.intent?.neutral.background}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
